import { ActivityLog } from "./ActivityLog";
import { logLocation } from "./utils";

type Metadata = Record<string, unknown>;

export interface ICheckoutActivityLogParams {
    message: string;
    visitorId?: string | null;
    action?: string | null;
    checkoutSessionId?: string | null;
    bookingId?: string | null;
    channelBookingId?: string | null;
    propertyId?: string | null;
    where?: string | null;
    metadata?: Metadata | null;
}

export class CheckoutActivityLog extends ActivityLog {
    public constructor({
        message,
        visitorId = null,
        action = null,
        checkoutSessionId = null,
        bookingId = null,
        channelBookingId = null,
        propertyId = null,
        where = null,
        metadata = null,
    }: ICheckoutActivityLogParams) {
        super({
            scope: "checkout",
            action: action ?? "",
            message,
            where: where ?? logLocation(3),
            metadata: {
                ...(metadata ?? {}),
                visitor_id: visitorId ?? undefined,
                property_id: propertyId ?? undefined,
                booking_id: bookingId ?? undefined,
                channel_booking_id: channelBookingId ?? undefined,
                checkout_session_id: checkoutSessionId ?? undefined,
            },
        });
    }

    public static create(params: ICheckoutActivityLogParams): CheckoutActivityLog {
        return new CheckoutActivityLog({
            ...params,
            action: params.action ?? "",
        });
    }
}
